import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
    <motion.div
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
        className={className}
    >
        {children}
    </motion.div>
);

export const SectionHeader = ({ number, label, title, description, align = "left" }) => (
    <div className={`mb-14 md:mb-20 ${align === "center" ? "text-center" : ""}`} data-testid={`section-header-${label.toLowerCase().replace(/\s+/g, "-")}`}>
        <Reveal>
            <p className="font-mono text-xs md:text-sm uppercase tracking-[0.3em] text-cyan-400 mb-4">
                {number}. {label}
            </p>
        </Reveal>
        <Reveal delay={0.1}>
            <h2 className={`font-display text-4xl md:text-5xl font-bold tracking-tight text-white max-w-2xl ${align === "center" ? "mx-auto" : ""}`}>
                {title}
            </h2>
        </Reveal>
        {description && (
            <Reveal delay={0.2}>
                <p className={`mt-5 text-base md:text-lg text-zinc-400 leading-relaxed font-light max-w-xl ${align === "center" ? "mx-auto" : ""}`}>
                    {description}
                </p>
            </Reveal>
        )}
    </div>
);
